<template>
  <div id="app">
    <keep-alive :include="keepAlive">
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    window.addEventListener('unload', this.saveState)
  },
  methods: {
    saveState () {
      sessionStorage.setItem('userInfo', JSON.stringify(this.$store.state.user))
      sessionStorage.setItem('token', this.$store.getters.getToken.token)
    }
  },
  computed: {
    keepAlive () {
      return this.$store.getters.keepAlive
    }
  }
}
</script>

<style>
html {
  height: 100%;
  font-size: 1em;
}
body {
  background-color: #EBF2F8;
  padding: 0px;
  margin: 0px;
  height: 100%;
}
#app {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue